import { AppMode, BetbyBonusBehavior, CatalogFilter, EndpointType, Theme } from '../types';
// SEO configuration for Fomo brand
const themeSetting = {
    theme: Theme.Fomo,
    rankConfig: { sublevelFormat: 'numeric' },
    betbyEnabled: true,
    betbyBonusBehavior: BetbyBonusBehavior.NoBonusMoney,
    betbyThemeName: 'fomo',
    brand: 'fomo.io',
    brandTitle: 'Fomo',
    canonicalUrl: 'https://fomo.io',
    languageRedirects: { ko: 'https://kr.fomo.io' },
    cdnBase: 'https://cdn.fomo.io',
    cdnTiles: 'https://tiles.fomo.io',
    cdnBanners: 'https://images.fomo.io/',
    discordLink: '',
    fingerprintjs: 'RRJpTry7JPqVq4qwU8TR',
    fingerprintjsHost: 'fp.fomo.io',
    googleAnalytics: '',
    googleClientId: '1030216308308-9ceh2uirt0ltfdb0duunbmg83kp41s9a.apps.googleusercontent.com',
    googleTagManager: '',
    languageDefault: 'en',
    languages: ['en', 'ja', 'ko'],
    languagesTiles: ['ja', 'ko'],
    languagesAutoAccept: ['en', 'ja', 'ko'],
    intercomId: 'e6olp9gz',
    supportEmail: 'support@fomo.io',
    telegramLink: '',
    xLink: 'https://x.com/fomo_io',
    noIndex: false,
    gameSetLimit: 60,
    themePath: 'fomoio',
    verbiageLabel: 'fomoio',
    ui: {
        mobileMenu: {
            mobileMenuStyle: 'alternative',
            showRewardsAndPromo: false,
            showChat: false,
            showSpecialBets: true,
            showPoints: true,
            itemOrder: ['menu', 'casino', 'special-bets', 'sports', 'fomo-points']
        },
        accordion: {
            accordionStyle: 'alternative'
        },
        background: {
            backgroundStyle: 'solid'
        },
        bannerSwiper: {
            bannerSwiperStyle: 'alternative'
        },
        cardSwiper: {
            cardSwiperStyle: 'default',
            viewAllAsButton: true,
            showNavigationArrows: false,
            disableEdgeMask: true
        },
        button: {
            buttonStyle: 'solid-static',
            useUppercaseAsDefault: true
        },
        betby: {
            betslipBottom: 20,
            customUI: true
        },
        betfeed: {
            betfeedStyle: 'default',
            usedVerbiage: 'live'
        },
        cashier: {
            useAcceptDeclineBonusType: false,
            withdrawOnlyUsdt: true,
            withdrawOnlyUsdtMemeCoins: true,
            showConversionRateDeposit: true,
            showProgressBarBonusMoney: false,
            useBuyCryptoIFrame: false,
            buyCryptoMaxAmount: 5000,
            buyCryptoMinAmount: 15,
            showQrCodeBuyCrypto: false,
            useSearchInputOnCryptoDropdown: false,
            showImageOnDepositBonusOffers: true,
            depositBonusWageringContributions: [
                { category: 'slots', percentage: 100 },
                { category: 'originals', percentage: 5 },
                { category: 'live_casino', percentage: 0 },
                { category: 'table_games', percentage: 0 }
            ],
            showWithdrawalWarningIfNoFunds: true,
            showWithdrawalPlayRequirementImmediately: true,
            cashierStyle: 'alternative',
            useCashierHomeScreen: false,
            useSidetabs: true,
            buyCryptoEnabled: true,
            useCashierV4: false
        },
        casinoLobby: {
            casinoLobbyStyle: 'alternative',
            showLiveWins: false,
            useAlternateOriginalsCategoryTitle: true
        },
        chat: {
            chatStyle: 'alternative'
        },
        checkbox: {
            useAlternativeTick: true,
            checkboxStyle: 'alternative'
        },
        dropdown: {
            dropdownStyle: 'alternative',
            useDropdownBackgroundImage: false
        },
        emailVerify: {
            emailVerifyStyle: 'alternative'
        },
        footer: {
            footerStyle: 'alternative',
            useEmbeddedShellDecor: false
        },
        games: {
            showRacesLeaderboard: false,
            showNavigationOnMobile: false,
            showLikeButton: false,
            showLogoWhenPlayingDesktop: false,
            showGameInfoModalOnGamePathMobile: false,
            applyPedestalIllustrationHueShift: true,
            useCompactRacesLeaderboardInfoBackdrop: true,
            showRacesLeaderboardPerimeterIllustrations: false
        },
        header: {
            headerStyle: 'alternative',
            buttonLoginVariant: 'secondary',
            useTightRewardsToggleHorizontalPadding: false
        },
        helpdesk: {
            useDynamicBonusTerms: true
        },
        home: {
            homeStyle: 'alternative',
            showBuyCryptoBanner: false,
            showLiveWins: false,
            cryptoBannerStyle: 'alternative',
            buyCryptoBannerArtStyle: 'minimal',
            useAlternateOriginalsCategoryTitle: true
        },
        icons: {
            vipHeaderGlyphDarkFill: false,
            statusIconsUseWarmPalette: true,
            expandSectionToggleUsesMintAccent: false,
            navIconPickerAllowRemoteAssets: true,
            navIconPickerUseBundledIconFactories: true
        },
        infoCard: {
            infoCardStyle: 'solid'
        },
        input: {
            inputStyle: 'alternative'
        },
        layout: {
            layoutStyle: 'default',
            isContrastTextColor: false,
            useCompactVerticalPagePadding: true,
            useReducedMarginsInHomePage: false,
            useCurrentColorSidebar: true,
            useReferralIconAnimated: false,
            useNewIcons: false,
            useRemoteIcons: false,
            showCryptoPriceDropdown: false,
            showUpdownGameDropdown: true,
            useReferralBannerOnlyImageCustom: true,
            usePromoItemContentCustom: true,
            useCentralButtonOnMobileMenu: false,
            sectionIconSize: 24,
            useExpandedRankPresentation: true
        },
        liveWins: {
            liveWinsStyle: 'alternative',
            usedVerbiage: 'live_wins',
            useSpecialWinCards: false
        },
        loading: {
            useLottie: false,
            publicInitPageLoadDisplayFor: 3000,
            playerInitPageLoadDisplayFor: 3000
        },
        maintenance: {
            maintenanceStyle: 'default',
            contentSource: 'hardcoded',
            useUppercaseBrandTitle: true
        },
        geoblock: {
            contentSource: 'hardcoded'
        },
        modal: {
            modalStyle: 'flat'
        },
        walletDropdown: {
            showBalancePreferenceToggles: false
        },
        notifications: {
            notificationsStyle: 'alternative',
            useBorderedPlayerNotificationsIcon: true,
            useGradientPublicNotificationsIcon: true,
            useExtendedDepositNotificationTitles: true
        },
        toasts: {
            toastsStyle: 'default'
        },
        profileModal: {
            profileModalStyle: 'alternative',
            useStarsBackgroundOnFavouriteToken: false,
            useTokenArtBackgroundOnDesktop: true,
            useCompactFavouriteTokenMobileCard: true
        },
        promotions: {
            showExpiredPromotions: false,
            useAspectRatioBoxDetailCustom: true,
            limitedCashbackExpired: new Date('2027-01-01T00:00:00Z').getTime(),
            promotionsStyle: 'alternative'
        },
        provider: {
            providerStyle: 'alternative',
            useSolidPrimaryGameCountBadge: true,
            hideProvidersHeroTitle: true
        },
        referral: {
            referralDashboardBannerType: 'onlyImage',
            faqTitleStyle: 'headline',
            faqVisibilityPreset: 'hide_getting_started',
            accordionGlassStyle: false,
            rulesCardsStyle: 'illustrated',
            rulesFootnoteMuted: false,
            highlightStepTitles: true,
            rankProgressPalette: 'warm',
            usePrefixedVerbiageKeys: true,
            shareModalStyle: 'rich',
            shareMessageVariant: 'campaign',
            shareBannerStyle: 'elevated',
            referralDashboardBannerStyle: 'elevated'
        },
        affiliates: {
            usePrefixedVerbiageKeys: true
        },
        rewardsDropdown: {
            rewardsDropdownStyle: 'alternative',
            useComfortableRewardsTimerLabels: true,
            showSeasonalRewardsCampaignTabs: false
        },
        settings: {
            settingsStyle: 'alternative',
            useAlternateSettingsChrome: true
        },
        sidebar: {
            sidebarStyle: 'alternative',
            showLuckyDip: false,
            showBanner: false
        },
        table: {
            tableStyle: 'alternative'
        },
        tabs: {
            tabsStyle: 'alternative',
            useCompactTabStripRadius: true,
            tabButtonsDefaultVariant: 'tertiary'
        },
        text: {
            successTextUsesWarmTone: true
        },
        toggle: {
            toggleStyle: 'alternative'
        },
        tooltip: {
            tooltipStyle: 'alternative'
        },
        topSection: {
            casinoTopSectionStyle: 'alternative'
        },
        transactions: {
            transactionsStyle: 'alternative',
            useSegmentedTabs: true,
            useElevatedRows: true,
            showEmptyStateIllustration: false
        },
        vip: {
            vipDashboardStyle: 'alternative',
            vipAboutStyle: 'alternative',
            scaleRewardsImages: false,
            useMarkdownFaqs: true,
            heroCardOpacity: 0.9,
            rewardsTableLayout: 'summary',
            rewardsProgressPalette: 'warm',
            includeWageringRequirementRow: true,
            reorderPrimaryBenefitCards: true,
            testimonialsHeaderStyle: 'headline',
            useCompactTestimonialsCardHeight: true,
            faqListLength: 'short',
            usePrefixedVerbiageKeys: true,
            assetSet: 'elevated',
            negativeBadgeTone: 'rose',
            showRankPrefixBeforeDisplayName: true,
            useAccentPendingTotalsBadge: true,
            useBorderOnMiniVipCalendarCard: true,
            useCompactClubOverviewSectionHeights: true,
            useCompactRoyaltyBannerTypography: true,
            useExpandedRoyaltyBannerSectionSpacing: true,
            useGradientVipCalendarDateHeader: true,
            useTallerRoyaltyBannerOnNarrowScreens: true,
            showRoyaltyBannerInDashboard: false,
            calendarSummaryLabel: 'claimed',
            includeRaceInRakebackBreakdown: false,
            showVipRewardTooltips: false,
            monthlyRewardsTooltipStyle: 'compact',
            useClassicVipCalendarCardChrome: false,
            rakeboostProgressTone: 'accent'
        },
        profileDropdown: {
            showSupport: false,
            profileDropdownStyle: 'default',
            useAlternateProfileMenuChrome: true
        }
    }
};
const themeSettings = [
    {
        ...themeSetting,
        brand: 'kr.fomo.io',
        brandTitle: '포모',
        canonicalUrl: 'https://kr.fomo.io',
        languageDefault: 'ko',
        languages: ['ko'], // KR site is Korean-only; hides language picker
        languagesAutoAccept: [],
        languageRedirects: undefined // no cross-site redirects on KR
    },
    {
        ...themeSetting,
        brand: 'fo.playeradmin.xyz',
        brandTitle: 'Fomo Moderator',
        googleAnalytics: '',
        googleTagManager: '',
        noIndex: true
    },
    {
        ...themeSetting,
        brand: 'gamma.fomo.io',
        languages: ['en', 'fr', 'ja', 'ko'],
        noIndex: true
    },
    {
        ...themeSetting,
        brand: 'alpha-fomo.previewenv.net',
        languages: ['en', 'fr', 'ja', 'ko', 'th'],
        noIndex: true
    },
    {
        ...themeSetting,
        brand: 'fomo-dev.previewenv.net',
        languages: ['en', 'ja', 'ko', 'th'],
        noIndex: true,
        languageRedirects: {}
    },
    {
        ...themeSetting,
        brand: 'localhost',
        languages: ['en', 'ja', 'ko', 'th'],
        noIndex: true,
        languageRedirects: {}
    }
];
export const getThemeSetting = (domain, fullDomain) => {
    const setting = themeSettings.find((s) => fullDomain.includes(s.brand));
    if (setting)
        return setting;
    if (domain.includes('ko') ||
        domain.includes('kr') ||
        fullDomain.includes('ko') ||
        fullDomain.includes('kr'))
        return themeSettings.find((s) => s.brand === 'kr.fomo.io') ?? themeSettings[0];
    return themeSetting;
};
export const endpointSettings = [
    {
        name: 'fomo',
        theme: Theme.Fomo,
        base: 'api.fomo.io',
        baseCurrency: 'USDT',
        baseCurrencySymbol: '$',
        baseCurrencyDigits: 2,
        betbyBrandId: '2521642017990250504',
        betbyEnabled: true,
        betbyScriptUrl: 'https://fomo.sptpub.com/bt-renderer.min.js',
        realm: 'prod-fomo',
        catalogFilter: CatalogFilter.ReleaseGames,
        endpointType: EndpointType.Production,
        gamityBrandRef: 'fomo',
        gamityCurrency: 'USDT',
        gamityEnvironment: 'production',
        reownProjectId: '441421829a4cc3f2eaf2cccd9a34afff',
        integrationRef: 'visionlink-gametech-as',
        optimoveTenantId: '1580',
        optimoveTenantToken: '695bf7e91a9840f4a535bbff918564ca',
        microsoftClarityId: 'u0hhgckxig'
    }
];
export const endpointSetting = (appMode, // eslint-disable-line @typescript-eslint/no-unused-vars
domain, // eslint-disable-line @typescript-eslint/no-unused-vars
fullDomain // eslint-disable-line @typescript-eslint/no-unused-vars
) => {
    return endpointSettings[0];
};
